<ion-row class="ion-align-items-center">
    <ion-col class="ion-align-items-center" size="12" size-md="2">
        <h6>{{ ruleNameKey | translate }}</h6>
    </ion-col>
    <ion-col size="12" size-md="10">
        @if (content) {
            <p class="content">{{ content }}</p>
        }
        <ng-content/>
    </ion-col>
</ion-row>
